var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s(new Date().getFullYear())+" © 開發團隊 "),_c('a',{attrs:{"href":"https://jbravo.com.tw"}},[_vm._v("嵩鴻數位有限公司")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }